// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"f1b20b5bda34236eba4f","678":"6f5d9f459c45b4d3d793"}[chunkId] + ".js";
};